import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { ref, reactive } from 'vue';
import { useSdkStore } from '@/stores/sdk'

import { ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/user'

export default /*@__PURE__*/_defineComponent({
  __name: 'TemplateItem',
  props: {
    template: {},
    type: {}
  },
  setup(__props: any) {

const sdkStore = useSdkStore()

const desginsdk = sdkStore.getSdk()
const props = __props
const userStore = useUserStore()
const islogin = userStore.isLoggedIn

const useTemplate = async (item) => {
    if (!islogin) {
        try {
            await ElMessageBox.confirm(
                '您还未登录，请先登录后再使用模板功能',
                '登录提示',
                {
                    confirmButtonText: '去登录',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: true
                }
            )
                // 用户点击"去登录"，跳转到登录页面
                ; (window as any).openGlobalLogin?.()
        } catch {
            // 用户点击"取消"或关闭对话框，不做任何操作
            return
        }
        return
    };
    console.log('props.template.value---', props.template)
    let templates = props.template.fileUrl.split(',')
    for (let i = 0; i < templates.length; i++) {
        await useMaterialTemplate(templates[i])
    }
}
const useMaterialTemplate = async (item) => {
    const fileSuffix = item.split('.').pop()
    if (['jpg', 'jpeg', 'png', 'webp'].includes(fileSuffix)) {
        desginsdk.addElement.createImageElement(item)
        return
    }
    desginsdk.designOpt.requireFile(item)

}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["template-item", { 'bigimg': __props.type === 'category' }]),
    onClick: useTemplate
  }, [
    _createElementVNode("img", {
      src: __props.template.previewUrl,
      alt: "",
      class: "template-image"
    }, null, 8, _hoisted_1)
  ], 2))
}
}

})